import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { ReportViewerService, ReportData } from 'src/app/Service/report-viewer.service';

@Component({
  selector: 'app-report-viewer-modal',
  templateUrl: './report-viewer-modal.component.html',
  styleUrls: ['./report-viewer-modal.component.css']
})
export class ReportViewerModalComponent implements OnInit {

  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('pdfIframe', null) pdfIframe: ElementRef;

  // Datos del reporte actual
  titulo: string = 'Reporte';
  nombreArchivo: string = 'reporte.pdf';
  pdfBlob: Blob | null = null;
  pdfUrl: SafeResourceUrl | null = null;
  pdfObjectUrl: string = '';

  private subscription: Subscription;

  constructor(
    private sanitizer: DomSanitizer,
    private reportService: ReportViewerService
  ) { }

  ngOnInit() {
    // Escuchar cuando el servicio envíe un nuevo reporte
    this.subscription = this.reportService.report$.subscribe((reportData: ReportData) => {
      if (reportData && reportData.blob) {
        this.mostrarPDF(reportData);
      } else {
        this.cerrarModal();
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.limpiarPDF();
  }

  /**
   * Muestra el PDF en el modal
   */
  private mostrarPDF(reportData: ReportData) {
    this.limpiarPDF();

    this.titulo = reportData.titulo;
    this.nombreArchivo = reportData.nombreArchivo || 'reporte.pdf';
    this.pdfBlob = reportData.blob;

    // Crear URL del blob
    this.pdfObjectUrl = URL.createObjectURL(reportData.blob);
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfObjectUrl);

    // Abrir el modal
    this.abrirModal();
  }

  /**
   * Abre el modal
   */
  private abrirModal() {
    if (this.btnshow) {
      this.btnshow.nativeElement.click();
    }
  }

  /**
   * Descarga el PDF
   */
  descargarPDF(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.pdfBlob || !this.pdfObjectUrl) return;

    const link = document.createElement('a');
    link.href = this.pdfObjectUrl;
    link.download = this.nombreArchivo;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  /**
   * Imprime el PDF
   */
  imprimirPDF(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.pdfIframe) return;

    const iframe = this.pdfIframe.nativeElement;
    if (iframe.contentWindow) {
      iframe.contentWindow.print();
    }
  }

  /**
   * Cierra el modal
   */
  cerrarModal(event?: Event) {
    // if (event) {
    //   event.preventDefault();
    //   event.stopPropagation();
    // }
    // this.btnclose.nativeElement.click();
    this.limpiarPDF();

    // Cerrar el modal con jQuery (Bootstrap)
    // $('#reportViewerModal').modal('hide');
  }

  /**
   * Limpia los recursos del PDF
   */
  private limpiarPDF() {
    if (this.pdfObjectUrl) {
      URL.revokeObjectURL(this.pdfObjectUrl);
    }
    this.pdfBlob = null;
    this.pdfUrl = null;
    this.pdfObjectUrl = '';
  }

}
